/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    shape, bool, string, arrayOf, array,
} from 'prop-types';
import AddressHelper from '../Helper/AddressHelper';

const ShippingAddress = ({ ROSSRecipient, isROSSPassport }) => (
    <>
        <h2 className="gray-color">
            {isROSSPassport ? (
                'Recipient'
            ) : (
                <>
                    <div className="split align-center">
                        <div className="align-left">
                            Shipping Address
                        </div>
                    </div>
                </>
            )}
        </h2>
        <div className="margin-bottom">
            <div className="bold">
                {ROSSRecipient.firstName} {ROSSRecipient.lastName}
            </div>
            {ROSSRecipient.businessName && !isROSSPassport ? (
                <div>{ROSSRecipient.businessName}</div>
            ) : (
                ''
            )}
            {ROSSRecipient?.addressDetail?.[0] && !isROSSPassport ? (
                <AddressHelper
                    address={ROSSRecipient.addressDetail[0]}
                    phone={ROSSRecipient.phones[0].phone[0] || {}}
                />
            ) : (
                ''
            )}
        </div>
    </>
);

ShippingAddress.defaultProps = {
    ROSSRecipient: {
        firstName: '',
        lastName: '',
        businessName: '',
    },
    isROSSPassport: false,
};

ShippingAddress.propTypes = {
    ROSSRecipient: shape({
        recId: string.isRequired,
        recipientEnable: string.isRequired,
        recipientEnableReason: string.isRequired,
        customerId: string.isRequired,
        firstName: string.isRequired,
        lastName: string.isRequired,
        businessName: string.isRequired,
        emailAddress: string.isRequired,
        recipientFullName: string.isRequired,
        addressDetail: arrayOf(shape({
            addressLine1: string.isRequired,
            addressLine2: string,
            addressLine3: string.isRequired,
            cityName: string.isRequired,
            state: string.isRequired,
            countryCode: string.isRequired,
            zipCode: string.isRequired,
            addressType: string.isRequired,
            attentionText: string.isRequired,
        })).isRequired,
        phones: array.isRequired,
    }),
    isROSSPassport: bool,
};

export default ShippingAddress;
